//this is replicated from costar-cosmos package
//packages/theme-ui/theme-ui/src/_svg/error-message-artwork.tsx

import { cn } from "@costar-ui/cosmos";

export const ErrorArtWork = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 440 180"
      xmlSpace="preserve"
      className={cn("w-full max-w-4xl", className)}
    >
      <g clipPath="url(#clip0_254_9013)">
        <rect width="436" height="200" fill="white" />
        <g clipPath="url(#clip1_254_9013)">
          <rect
            width="410"
            height="168"
            transform="translate(15 14)"
            fill="white"
          />
          <path
            d="M169.474 60.4695V65.3748L164.769 63.4224V58.5171L169.474 60.4695Z"
            fill="#C5E2F9"
          />
          <path
            d="M425 182H15V112.403H19.7285L19.5005 85.945L23.1099 80.7018H35.749L36.7262 81.4562V90.7658L49.2973 90.7553L51.321 98.5651L55.7007 102.032L55.7928 92.673L65.4839 93.3429C65.4839 93.3429 65.487 93.3459 65.493 93.355C65.496 93.3595 65.5005 93.3641 65.5051 93.3716C65.5096 93.3776 65.5141 93.3852 65.5217 93.3927C65.5308 93.4048 65.5413 93.4184 65.5519 93.435C65.5836 93.4787 65.6274 93.5361 65.6803 93.6085C65.6969 93.6326 65.7165 93.6583 65.7377 93.687C65.7467 93.699 65.7573 93.7126 65.7663 93.7262C65.8026 93.776 65.8419 93.8273 65.8826 93.8861C65.9189 93.9344 65.9566 93.9857 65.9959 94.04C66.0231 94.0777 66.0533 94.1185 66.0835 94.1592C66.156 94.2558 66.233 94.3614 66.3146 94.4731C66.3538 94.5259 66.3931 94.5802 66.4339 94.636C66.7888 95.1204 67.2131 95.7043 67.6662 96.335C67.7025 96.3848 67.7387 96.4346 67.7734 96.4828C67.8459 96.5839 67.9184 96.6865 67.9924 96.7907C68.0287 96.842 68.0664 96.8933 68.1027 96.9446C68.1389 96.9974 68.1752 97.0487 68.2114 97.1C68.2582 97.1664 68.3066 97.2312 68.3534 97.2976C68.6222 97.6779 68.8925 98.0611 69.1553 98.4383L69.6763 98.4791L69.7639 98.4851L69.8379 98.4896L70.1732 98.5138L70.5372 98.5439L70.7758 98.5651H70.7818C70.8105 98.0777 70.8392 97.5903 70.8785 97.1015C70.9177 96.5975 70.9615 96.0951 71.0053 95.5911C71.0144 95.4312 71.0295 95.2743 71.0446 95.1128C71.1654 93.7594 71.3074 92.4059 71.4629 91.057C71.5158 90.5697 71.5747 90.0763 71.6366 89.5874V89.5768C71.6366 89.5678 71.6426 89.5572 71.6426 89.5467C71.8224 88.0318 72.0262 86.5229 72.2498 85.0126C72.3192 84.5086 72.3947 84.0062 72.4733 83.5022C72.6923 82.0326 72.9354 80.563 73.1846 79.1039C73.1936 79.0602 73.1997 79.0134 73.2088 78.9681C73.2963 78.4641 73.3885 77.9617 73.4957 77.4577C73.8068 75.9278 74.1964 74.4129 74.6495 72.9236C74.8051 72.4152 74.9712 71.9127 75.1418 71.4133C75.2053 71.2171 75.2732 71.027 75.3412 70.8339L75.3457 70.8294C75.823 69.4865 76.3621 68.1678 76.9571 66.8792C77.0644 66.6438 77.1701 66.4114 77.2834 66.1791C77.4102 65.9075 77.5461 65.6404 77.6775 65.3688C78.4553 63.8087 79.3222 62.2938 80.26 60.8347C80.3763 60.6537 80.4986 60.4771 80.6149 60.2961C80.6935 60.1754 80.775 60.0486 80.8626 59.9128C80.9789 59.7272 81.1057 59.5311 81.2326 59.3244C81.9817 58.146 82.9346 56.7835 84.176 56.5119C84.2349 56.4968 84.2923 56.4862 84.3512 56.4772C84.4494 56.4621 84.54 56.4576 84.6472 56.4576C84.6623 56.4576 85.1048 56.4621 85.7723 56.4681C86.8129 56.4832 88.3986 56.4983 89.7367 56.5119H89.9119C89.9466 56.5119 89.9814 56.5149 90.0146 56.5149C90.0297 56.5149 90.0448 56.5179 90.0599 56.5179C90.0916 56.5209 90.1233 56.5239 90.155 56.527C90.1852 56.53 90.2154 56.5345 90.2456 56.5405C90.2623 56.5436 90.2804 56.5466 90.297 56.5496C90.3181 56.5526 90.3378 56.5571 90.3589 56.5617C90.377 56.5647 90.3952 56.5692 90.4133 56.5737C90.5537 56.6054 90.6866 56.6507 90.8165 56.7065C90.8422 56.7171 90.8679 56.7292 90.8935 56.7427C90.9101 56.7488 90.9268 56.7578 90.9419 56.7654C90.9781 56.782 91.0113 56.8016 91.0446 56.8212C91.1457 56.877 91.2424 56.9419 91.333 57.0143C91.3632 57.037 91.3919 57.0626 91.4221 57.0868C91.4478 57.1079 91.4735 57.1305 91.4991 57.1547C91.5324 57.1863 91.5641 57.2165 91.5958 57.2497C91.6139 57.2693 91.632 57.2874 91.6502 57.3086C91.6622 57.3221 91.6743 57.3342 91.6849 57.3478C91.7106 57.378 91.7362 57.4096 91.7619 57.4413C91.848 57.5485 91.9235 57.6646 91.9884 57.7869C92.0081 57.8216 92.0262 57.8578 92.0428 57.894C92.0549 57.9181 92.0655 57.9423 92.076 57.9664C92.0791 57.9725 92.0821 57.9785 92.0836 57.986C92.0957 58.0117 92.1047 58.0358 92.1153 58.063C92.1274 58.0932 92.1395 58.1233 92.15 58.1535C92.15 58.1565 92.1531 58.1595 92.1531 58.1626C92.1636 58.1912 92.1727 58.2199 92.1818 58.2486C92.1938 58.2863 92.2044 58.3255 92.215 58.3647C92.2331 58.4342 92.2482 58.5051 92.2603 58.576C92.2633 58.5911 92.2663 58.6077 92.2678 58.6228C92.2784 58.6907 92.286 58.7601 92.2905 58.8295C92.2905 58.8491 92.2935 58.8672 92.2935 58.8868C92.2965 58.917 92.2965 58.9472 92.2965 58.9773L92.7239 88.8722L92.9474 88.8873L93.3175 88.9129C93.3175 88.9129 94.5377 70.7479 95.1025 64.7909C95.2566 63.1357 95.4786 61.6586 95.7535 60.3429C98.5096 47.1691 106.636 50.048 106.636 50.048L106.783 50.1732L107.751 51.0076L108.84 48.1136L109.346 48.4048L109.486 48.4863L123.803 56.794V93.2735H129.155L134.822 103.027L134.831 102.363L134.953 93.2735H129.154V16.476L136.037 14H147.003L147.888 14.7393V58.5171H164.914V62.92H171.152L175.861 64.8724V110.45L177.617 107.875L179.139 107.915L183.928 116.612L183.966 116.68H184.04L185.41 116.661L186.675 116.646L190.656 116.594L191.872 112.655L193.015 112.594L193.653 112.56H193.657L193.861 132.225H202.619L204.697 137.563H205.582L213.044 137.327L214.06 137.296L216.143 137.231L216.172 123.518L216.413 112.849L216.59 105.037L217.301 73.6102L217.615 59.7453L217.698 56.0472H219.157V51.0996H221.507V48.7247L222.907 48.4305L224.976 47.9959L232.861 48.4109L233.196 48.429L233.618 49.5018L236.185 56.0472V97.8106H240.806V93.4078H241.882V90.962H242.952L244.26 90.9589L244.212 77.5981H247.598C247.88 77.5981 248.157 77.6177 248.43 77.6584C249.134 77.7565 249.8 77.9768 250.407 78.3012C251.866 79.0752 252.983 80.4347 253.479 82.0748H254.871V82.9666H255.644L256.315 85.2902L256.612 85.3596L257.519 85.5693L261.48 86.4882V93.2796H268.894L270.762 89.1694H272.468L272.465 90.3282L272.425 110.138H275.344V72.3578L277.534 71.6441V66.9501L289.939 66.3601V63.8434L290.831 63.7619L292.769 63.5839L295.44 63.3394H295.456V37.5984L295.46 37.5939L296.451 37.0492L296.52 37.0115L296.569 36.9858V36.6886L298.242 35.314L299.482 35.1556L300.133 35.0726V34.5747H300.152V33.769L304.899 33.4023H304.911H304.917L305.689 33.4642L306.501 33.5336L308.826 33.7207V34.5762L309.881 34.9383V124.102H317.908V80.658L318.896 79.893H332.746V71.6457H336.395V54.5383L336.39 39.4619H336.395L338.34 38.1839H353.909V54.5383H355.368V87.4976H362.179V97.7563H360.753V148.786H362.199V128.884H365.828V102.844L366.109 102.594L367.793 101.091L369.147 99.8838L369.217 99.8234L370.845 98.3719H370.846L371.924 98.5802L372.036 98.6013L378.891 99.923H378.894L379.817 100.101L380.095 100.155L380.161 100.169L380.417 100.219L390.641 102.189L390.724 102.206L392.095 102.47L394.043 102.846V117.061H399.88V126.998H410.213V128.885L412.098 129.341L424.126 132.249L424.204 132.268L424.506 151.429L424.989 182.003L425 182Z"
            fill="#D8EBFD"
          />
          <path
            d="M224.978 47.996V141.085L214.06 137.296L213.871 137.231L213.9 123.518L214.323 105.037L215.427 56.6749L215.554 49.9786L221.509 48.7247L224.978 47.996Z"
            fill="#F8FBFF"
          />
          <path
            d="M136.037 14L134.957 93.2826H129.158V16.476L136.037 14Z"
            fill="#F8FBFF"
          />
          <path
            d="M362.206 87.5006V128.882H362.187V97.7548H360.761V148.784H356.777V87.5006H362.206Z"
            fill="#F8FBFF"
          />
          <path
            d="M333.544 142.524H331.761V72.4242L332.754 71.6487L333.544 142.524Z"
            fill="#F8FBFF"
          />
          <path
            d="M319.698 150.761H317.911V80.661L317.917 80.6565L318.905 79.8915L318.909 79.887V79.8915L319.698 150.761Z"
            fill="#F8FBFF"
          />
          <path
            d="M338.198 124.955H336.414L336.401 39.4619L338.349 38.1824L338.198 124.955Z"
            fill="#F8FBFF"
          />
          <path
            d="M394.081 98.3689H370.852V182H394.081V98.3689Z"
            fill="#F8FBFF"
          />
          <path
            d="M302.412 80.8375V182H281.494V82.4686L284.464 80.8375H302.412Z"
            fill="#F8FBFF"
          />
          <path
            d="M34.0319 80.7018V182H19.9913L19.7285 131.939L19.6319 112.404L19.5005 85.945L23.1084 80.7033L23.1099 80.7018H34.0319Z"
            fill="#F8FBFF"
          />
          <path
            d="M304.923 33.4023V140.33H295.447V37.609L295.462 37.6L296.575 36.6886L298.248 35.3156L300.142 33.7705H300.16L304.923 33.4023Z"
            fill="#F8FBFF"
          />
          <path
            d="M306.509 33.5487V182H297.031V38.1281L297.046 38.113L298.16 37.4234V35.7924H298.176L299.489 35.6038L301.726 35.2794V33.8158H301.744L304.919 33.4023H304.923L305.695 33.4687L306.509 33.5487Z"
            fill="#F8FBFF"
          />
          <path
            d="M109.491 182V48.4953V48.4923L109.35 48.4123H109.349L108.843 48.1196V48.1211L107.754 51.0136L106.786 50.1792V182H109.491Z"
            fill="#F8FBFF"
          />
          <path
            d="M196.123 115.881V150.761H193.653V112.56H193.657L196.123 115.881Z"
            fill="#F8FBFF"
          />
          <path
            d="M175.862 64.8724V157.125L171.152 167.277V62.9199L175.862 64.8724Z"
            fill="#C5E2F9"
          />
          <path
            d="M147.927 85.1001V182H147.003V14L147.888 14.7393V85.1001H147.927Z"
            fill="#C5E2F9"
          />
          <path
            d="M92.9489 88.8948V182.001H89.8651V56.5194H89.9088C89.9436 56.5194 89.9783 56.5224 90.0115 56.5224C90.0266 56.5224 90.0417 56.5254 90.0568 56.5254C90.0886 56.5285 90.1203 56.5315 90.152 56.5345C90.1822 56.5375 90.2124 56.542 90.2426 56.5481C90.2592 56.5511 90.2773 56.5541 90.294 56.5571C90.3151 56.5601 90.3347 56.5647 90.3559 56.5692C90.374 56.5722 90.3921 56.5767 90.4102 56.5813C90.5507 56.613 90.6836 56.6582 90.8135 56.7141C90.8391 56.7246 90.8648 56.7367 90.8905 56.7503C90.9071 56.7563 90.9237 56.7654 90.9388 56.7729C90.9751 56.7895 91.0083 56.8091 91.0415 56.8287C91.1427 56.8846 91.2394 56.9494 91.33 57.0219C91.3602 57.0445 91.3889 57.0701 91.4191 57.0943C91.4448 57.1154 91.4704 57.138 91.4961 57.1622C91.5293 57.1939 91.561 57.224 91.5928 57.2572C91.6109 57.2769 91.629 57.295 91.6471 57.3161C91.6592 57.3297 91.6713 57.3417 91.6819 57.3553C91.7075 57.3855 91.7332 57.4172 91.7589 57.4489C91.845 57.556 91.9205 57.6722 91.9854 57.7944C92.005 57.8291 92.0232 57.8653 92.0398 57.9015C92.0519 57.9257 92.0624 57.9498 92.073 57.9739C92.076 57.98 92.079 57.986 92.0806 57.9936C92.0926 58.0192 92.1017 58.0433 92.1123 58.0705C92.1244 58.1007 92.1364 58.1309 92.147 58.161C92.147 58.1641 92.15 58.1671 92.15 58.1701C92.1606 58.1988 92.1697 58.2274 92.1787 58.2561C92.1908 58.2938 92.2014 58.333 92.2119 58.3723C92.2301 58.4417 92.2452 58.5126 92.2573 58.5835C92.2603 58.5986 92.2633 58.6152 92.2648 58.6303C92.2754 58.6982 92.2829 58.7676 92.2875 58.837C92.2875 58.8566 92.2905 58.8747 92.2905 58.8943C92.2935 58.9245 92.2935 58.9547 92.2935 58.9849L92.7209 88.8797L92.9444 88.8948H92.9489Z"
            fill="#C5E2F9"
          />
          <path
            d="M224.978 105.036V157.127H174.8V105.036H175.862V110.45L177.618 107.875L179.141 107.915L183.966 116.68L190.656 116.594L191.872 112.655L193.653 112.56H193.657L196.123 115.881V132.224H202.619L204.695 137.563H205.58L214.06 137.296L213.871 137.231L213.9 123.518L214.323 114.757L224.978 105.036Z"
            fill="#C5E2F9"
          />
          <path
            d="M362.206 97.7548H362.187V128.882H362.206V97.7548Z"
            fill="#D8EBFD"
          />
          <path
            d="M370.852 182H356.778L356.777 152.632V148.784L357.549 148.49L360.761 147.268L361.057 147.156L361.829 146.862L362.206 146.719V128.882H365.835V102.843L366.116 102.592L367.8 101.089L369.153 99.8823L369.223 99.8204L370.851 98.3689L370.852 151.521V151.965V182Z"
            fill="#C5E2F9"
          />
          <path
            d="M331.76 79.8931L331.609 151.591L331.546 182H319.119L319.088 167.266L319.054 151.612L319.053 150.759V150.409L318.997 123.908L318.97 111.433L318.903 79.8931H331.76Z"
            fill="#C5E2F9"
          />
          <path
            d="M320.26 150.409H317.911V167.266H320.26V150.409Z"
            fill="#C5E2F9"
          />
          <path
            d="M135.18 182H123.807V93.281H129.16L134.835 102.37L135.05 151.936V151.965L135.18 182Z"
            fill="#C5E2F9"
          />
          <path
            d="M167.538 65.3749H151.541V70.4024H167.538V65.3749Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 73.1892H151.541V78.2167H167.538V73.1892Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 81.0035H151.541V86.031H167.538V81.0035Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 88.8179H151.541V93.8454H167.538V88.8179Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 96.6338H151.541V101.661H167.538V96.6338Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 104.448H151.541V109.476H167.538V104.448Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 112.262H151.541V117.29H167.538V112.262Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 120.077H151.541V125.104H167.538V120.077Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 127.891H151.541V132.919H167.538V127.891Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 135.705H151.541V140.733H167.538V135.705Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 143.52H151.541V148.547H167.538V143.52Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 151.334H151.541V156.362H167.538V151.334Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 159.305H151.541V164.333H167.538V159.305Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 159.462H151.541V164.49H167.538V159.462Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 167.277H151.541V172.304H167.538V167.277Z"
            fill="#F8FBFF"
          />
          <path
            d="M167.538 175.249H151.541V180.277H167.538V175.249Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5316 59.3319V60.8408H80.257C80.3733 60.6597 80.4956 60.4832 80.6119 60.3021C80.6905 60.1814 80.772 60.0562 80.8596 59.9204C80.9759 59.7348 81.1027 59.5386 81.2296 59.3319H88.5316Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5316 65.3749V66.8838H76.9526C77.0599 66.6469 77.1671 66.416 77.2788 66.1837C77.4057 65.9121 77.5416 65.645 77.673 65.3734H88.5316V65.3749Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 71.4193V72.9282H74.6465C74.802 72.4197 74.9682 71.9172 75.1373 71.4193H88.53H88.5315Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5316 77.4623V78.9711H73.2073C73.2949 78.4687 73.387 77.9647 73.4942 77.4623H88.5316Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 83.5052V85.0141H72.2482C72.3162 84.5117 72.3947 84.0077 72.4717 83.5052H88.53H88.5315Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 89.5481V91.057H71.4614C71.5143 90.5681 71.5732 90.0762 71.6366 89.5874V89.5768C71.6366 89.5662 71.6411 89.5572 71.6411 89.5466H88.5315V89.5481Z"
            fill="#F8FBFF"
          />
          <path
            d="M67.7734 96.4828C67.9199 96.6835 68.0649 96.8947 68.2114 97.1014H67.7734V96.4828Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 95.5927V97.1015H70.877C70.9162 96.5991 70.96 96.0951 71.0038 95.5927H88.5315Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.53 101.636H67.7734V103.144H88.53V101.636Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.53 107.678H67.7734V109.187H88.53V107.678Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.53 113.721H67.7734V115.23H88.53V113.721Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 119.764H70.7758V121.273H88.5315V119.764Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 125.809H70.7758V127.318H88.5315V125.809Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 131.852H70.7758V133.361H88.5315V131.852Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 137.895H70.7758V139.404H88.5315V137.895Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 143.938H70.7758V145.447H88.5315V143.938Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 149.981H70.7758V151.49H88.5315V149.981Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 156.025H70.7758V157.534H88.5315V156.025Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 162.068H70.7758V163.577H88.5315V162.068Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 168.111H70.7758V169.62H88.5315V168.111Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 168.111H70.7758V169.62H88.5315V168.111Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 174.154H70.7758V175.663H88.5315V174.154Z"
            fill="#F8FBFF"
          />
          <path
            d="M88.5315 180.198H70.7758V181.707H88.5315V180.198Z"
            fill="#F8FBFF"
          />
          <g opacity="0.5">
            <path
              d="M355.375 55.166V68.5812L337.916 89.862L338.289 72.8558L355.375 55.166Z"
              fill="#F8FBFF"
            />
            <path
              d="M355.375 76.2944V82.2272L338.24 101.248L338.142 94.4308L355.375 76.2944Z"
              fill="#F8FBFF"
            />
          </g>
          <g opacity="0.5">
            <path
              d="M147.003 20.9497V28.9798L135.711 37.9665L135.843 28.1997L147.003 20.9497Z"
              fill="#F8FBFF"
            />
            <path
              d="M147.003 32.9299V36.3973L135.624 44.3323L135.678 40.4169L147.003 32.9299Z"
              fill="#F8FBFF"
            />
          </g>
          <path
            d="M248.432 77.6584V136.571L244.487 138.69L244.215 80.0182V77.598H247.601C247.883 77.598 248.16 77.6176 248.433 77.6584H248.432Z"
            fill="#C5E2F9"
          />
          <path
            d="M287.909 80.8375H286.936V182H287.909V80.8375Z"
            fill="#D8EBFD"
          />
          <path
            d="M292.924 80.8375H291.952V182H292.924V80.8375Z"
            fill="#D8EBFD"
          />
          <path
            d="M297.937 80.8375H297.031V182H297.937V80.8375Z"
            fill="#D8EBFD"
          />
          <path
            d="M302.951 80.8375H301.978V182H302.951V80.8375Z"
            fill="#D8EBFD"
          />
          <path
            d="M309.889 81.3611L309.751 123.908L309.662 151.628L309.564 182H306.507V79.887H306.509L306.521 79.893L306.587 79.9217L309.889 81.3611Z"
            fill="#C5E2F9"
          />
          <path
            d="M319.696 123.908H308.91V182H319.696V123.908Z"
            fill="#C5E2F9"
          />
          <path
            opacity="0.5"
            d="M306.587 79.8931H286.936V182H306.587V79.8931Z"
            fill="#D8EBFD"
          />
          <path
            opacity="0.5"
            d="M89.7337 56.5194V182.001H69.6763V98.4821L69.7639 98.4881L69.8379 98.4926L70.1732 98.5168L70.5372 98.547L70.7758 98.5681H70.7818C70.8105 98.0807 70.8392 97.5934 70.8785 97.1045C70.9177 96.6005 70.9615 96.0981 71.0053 95.5941C71.0144 95.4342 71.0295 95.2773 71.0446 95.1158C71.1654 93.7624 71.3074 92.4089 71.4629 91.06C71.5158 90.5727 71.5747 90.0793 71.6366 89.5904V89.5798C71.6366 89.5708 71.6426 89.5602 71.6426 89.5497C71.8224 88.0348 72.0262 86.5259 72.2498 85.0156C72.3192 84.5116 72.3947 84.0092 72.4733 83.5052C72.6923 82.0356 72.9354 80.566 73.1846 79.1069C73.1937 79.0632 73.1997 79.0164 73.2088 78.9711C73.2963 78.4672 73.3885 77.9647 73.4957 77.4608C73.8068 75.9308 74.1964 74.4159 74.6495 72.9267C74.8051 72.4182 74.9712 71.9157 75.1418 71.4163C75.2053 71.2201 75.2732 71.03 75.3412 70.8369L75.3457 70.8324C75.823 69.4895 76.3621 68.1708 76.9571 66.8822C77.0644 66.6468 77.1701 66.4145 77.2834 66.1821C77.4102 65.9105 77.5461 65.6434 77.6775 65.3718C78.4553 63.8117 79.3222 62.2968 80.26 60.8377C80.3763 60.6567 80.4986 60.4802 80.6149 60.2991C80.6934 60.1784 80.775 60.0516 80.8626 59.9158C80.9789 59.7303 81.1057 59.5341 81.2326 59.3274C81.9817 58.149 82.9346 56.7865 84.176 56.5149C84.2349 56.4998 84.2923 56.4892 84.3512 56.4802C84.4494 56.4651 84.54 56.4606 84.6472 56.4606C84.6623 56.4606 85.1048 56.4651 85.7723 56.4711C86.8129 56.4862 88.3986 56.5013 89.7367 56.5149L89.7337 56.5194Z"
            fill="#F8FBFF"
          />
          <path
            d="M306.507 95.0071H286.936H286.861L281.492 97.1346V96.1976L286.8 94.0717H286.936H306.507V95.0071Z"
            fill="#D8EBFD"
          />
          <path
            d="M306.507 111.481H286.936L281.492 113.607V112.671L286.936 110.544H306.507V111.481Z"
            fill="#D8EBFD"
          />
          <path
            d="M306.507 144.425H286.936L281.492 146.551V145.616L286.936 143.49H306.507V144.425Z"
            fill="#D8EBFD"
          />
          <path
            d="M306.507 160.897H286.936L281.492 163.025V162.088L286.936 159.962H306.507V160.897Z"
            fill="#D8EBFD"
          />
          <path
            d="M306.507 177.371H286.936L281.492 179.497V178.561L286.936 176.434H306.507V177.371Z"
            fill="#D8EBFD"
          />
          <path
            d="M306.507 127.953H286.936L281.492 130.079V129.143L286.936 127.017H306.507V127.953Z"
            fill="#D8EBFD"
          />
          <path
            d="M70.7758 98.5651V118.118H55.7913V92.6715L65.4824 93.3414C65.4824 93.3414 67.4774 96.0227 69.1553 98.4383L70.5371 98.544L70.7758 98.5636V98.5651Z"
            fill="#C5E2F9"
          />
          <path
            d="M100.369 63.7769V182H91.41L91.5928 57.2572L95.755 60.3488L100.369 63.7769Z"
            fill="#C5E2F9"
          />
          <path
            d="M224.978 181.707H213.871L210.643 157.127L224.978 156.78V181.707Z"
            fill="#C5E2F9"
          />
          <path
            d="M204.008 154.866H202.875V182H204.008V154.866Z"
            fill="#C5E2F9"
          />
          <path
            d="M196.125 154.866H194.992V182H196.125V154.866Z"
            fill="#C5E2F9"
          />
          <path
            d="M188.24 154.866H187.107V182H188.24V154.866Z"
            fill="#C5E2F9"
          />
          <path
            d="M180.356 154.866H179.224V182H180.356V154.866Z"
            fill="#C5E2F9"
          />
        </g>
        <ellipse cx="217" cy="240" rx="322" ry="88" fill="white" />
        <path
          d="M168.582 68.2264C167.464 65.9032 168.023 62.4183 169.699 60.0951L216.647 11.3068C218.323 9.56439 221.118 9.56439 222.794 11.3068L270.301 60.0951C271.977 61.8375 272.536 65.3224 271.418 68.2264L222.794 176.258C221.677 178.581 220 178.581 218.882 176.258L168.582 68.2264Z"
          fill="#365CA2"
          stroke="white"
          strokeWidth="4"
        />
        <path
          d="M221.526 91.056H218.39L216.854 71.216V56.048H223.062V71.216L221.526 91.056ZM216.854 102V95.472H223.062V102H216.854Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_254_9013">
          <rect width="436" height="200" fill="white" />
        </clipPath>
        <clipPath id="clip1_254_9013">
          <rect
            width="410"
            height="168"
            fill="white"
            transform="translate(15 14)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
